import { defineStore } from "pinia";
import api from "../api";
import { useAuthStore } from "./auth";

export const useSavedRoutesStore = defineStore("savedRoutes", {
    state: () => ({
        ids: [] as number[],
        loaded: false,
    }),
    getters: {
        isSaved: (state) => (routeId: number) => state.ids.includes(routeId),
    },
    actions: {
        async fetchIds() {
            const auth = useAuthStore();
            if (!auth.isAuthenticated) {
                this.clear();
                return;
            }
            try {
                const res = await api.get<number[]>("/users/me/saved-routes");
                this.ids = res.data || [];
            } catch {
                this.ids = [];
            } finally {
                this.loaded = true;
            }
        },
        async save(routeId: number) {
            if (this.ids.includes(routeId)) return;
            this.ids = [routeId, ...this.ids];
            await api.post(`/users/me/saved-routes/${routeId}`);
        },
        async unsave(routeId: number) {
            this.ids = this.ids.filter((id) => id !== routeId);
            await api.delete(`/users/me/saved-routes/${routeId}`);
        },
        clear() {
            this.ids = [];
            this.loaded = false;
        },
    },
});
